$('#myModal').on('hidden.bs.modal', function() {
	var $modal = $('#myModal');
	$modal.find('.modal-title').text('');
	$modal.find('.modal-body').text('');
})
exports.modules = 'modal';